<template>
  <div :id="this.$route.name">
    <form @submit.prevent="this.$ValidForm(this)">
      <div class="card text-center">
        <div class="card-header" :class="ThemeTitleModal">
          <ul
            class="nav nav-tabs mt-3 card-header-tabs"
            id="myTab"
            role="tablist"
            dir="rtl"
          >
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Detail-tab"
                data-toggle="tab"
                href="#TanzimatAsli"
                role="tab"
                aria-controls="TanzimatAsli"
                aria-selected="true"
                >تنظیمات اصلی</a
              >
            </li>
          </ul>
        </div>
        <div class="tab-content" id="Controler">
          <div
            class="tab-pane fade show active"
            id="TanzimatAsli"
            role="tabpanel"
            aria-labelledby="Detail-tab"
          >
            <div id="Controler">
              <div class="container mt-3 mb-3 text-right">
                <div class="row">
                  <div class="col-lg-8 col-12">
                    <div class="row">
                      <div class="col-lg-6 col-12">
                        <div class="mt-3">
                          <span>کد کاربری </span>
                          <input
                            type="number"
                            class="form-control InputText required"
                            v-model="DataAxios.UserCode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <span>نام کاربری داشبورد</span>
                          <input
                            type="text"
                            class="form-control InputText required"
                            v-model="DataAxios.UserNameDashBoard"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12">
                        <div class="mt-3">
                          <span>نام کاربری</span>
                          <input
                            type="text"
                            class="form-control InputText required"
                            v-model="DataAxios.UserName"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <span>کلمه عبور</span>
                          <input
                            type="password"
                            class="form-control InputText required"
                            v-model="DataAxios.Pss"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12">
                        <div class="mt-3">
                          <span>مشخصات کاربر</span>
                          <input
                            type="text"
                            class="form-control InputText required"
                            v-model="DataAxios.NamFam"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <span>کد ملی</span>
                          <input
                            type="number"
                            maxlength="10"
                            class="form-control InputText required required-CodeMeli"
                            @input="$CheckupLengthCodeMeli($event)"
                            v-model="DataAxios.UserCodeMeli"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <div class="mt-3">
                      <vue-upload-multiple-image
                        :dragText="TitleUploaderLogo"
                        :browseText="ClearDescriptionUploaderLogo"
                        :primaryText="InfoUploaderLogo"
                        :popupText="DtlInfoUploaderLogo"
                        :multiple="MultipleImaegs"
                        @upload-success="uploadImageSuccess"
                        @before-remove="beforeRemove"
                        @edit-image="editImage"
                        :data-images="images"
                      ></vue-upload-multiple-image>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-lg-4 col-12">
                    <span>شماره موبایل کاربر</span>
                    <input
                      type="number"
                      class="form-control InputText"
                      v-model="DataAxios.UserMobile"
                    />
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <span>مخفف جهت چاپ</span>
                    <input
                      type="text"
                      class="form-control InputText"
                      v-model="DataAxios.MoxafafJahateChap"
                    />
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <span>شماره پرسنلی</span>
                    <input
                      type="text"
                      class="form-control InputText"
                      v-model.number="DataAxios.UserCustomerCode"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-4 col-12 text-right">
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="Rahbari"
                          @click="statusChk($event)"
                          :value="Rahbari"
                        />
                        <label class="custom-control-label" for="Rahbari"
                          >راهبر سیستم</label
                        >
                      </div>
                    </span>
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="Modir"
                          @click="statusChk($event)"
                          :value="Modir"
                        />
                        <label class="custom-control-label" for="Modir"
                          >مدیر سیستم</label
                        >
                      </div>
                    </span>
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="Disable"
                          @click="statusChk($event)"
                          :value="DisableUser"
                        />
                        <label class="custom-control-label" for="Disable"
                          >غیرفعال کردن کاربر</label
                        >
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button-save-data
          class="mb-3 mr-2"
          :DataParanet="DataAxios"
        ></button-save-data>
        <div v-for="Dataa in Data" :key="Dataa.id"></div>
      </div>
    </form>
  </div>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ButtonSaveData from "../Tools/ButtonSaveData.vue";
export default {
  components: {
    VueUploadMultipleImage,
    ButtonSaveData,
  },
  data() {
    return {
      images: [],
      TitleUploaderLogo: "بارگذاری عکس کاربری",
      ClearDescriptionUploaderLogo: "",
      InfoUploaderLogo: " بارگذاری موفق",
      DtlInfoUploaderLogo:
        "برای مشاهده عکس کاربر بارگذاری شده بر روی عکس لوگو کلیک کنید",
      MultipleImaegs: false,
      Theme: "bg-BlueGreen",
      DataAxios: null,
      Data: this.$store.state.TarifKarbaran.Data,
    };
  },
  computed: {
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    Rahbari: {
      get() {
        return this.$store.state.TarifKarbaran.Data[0].IsAdministrator;
      },
      set(value) {
        this.$store.state.TarifKarbaran.Data[0].IsAdministrator = value;
      },
    },
    Modir: {
      get() {
        return this.$store.state.TarifKarbaran.Data[0].IsUserAdmin;
      },
      set(value) {
        this.$store.state.TarifKarbaran.Data[0].IsUserAdmin = value;
      },
    },
    DisableUser: {
      get() {
        return this.$store.state.TarifKarbaran.Data[0].Archive;
      },
      set(value) {
        this.$store.state.TarifKarbaran.Data[0].Archive = value;
      },
    },
  },
  methods: {
    uploadImageSuccess(formData, index, fileList) {
      // console.log("data", formData, index, fileList);
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(done) {
      // var r = confirm("remove image")
      // if (r == true) {
      //     done()
      // }
      this.$swal({
        title: "حذف عکس کاربر",
        text: "از حذف عکس اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "حذف شود",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "حذف موفق",
            text: "عکس کاربری با موفقیت انجام شد",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "تایید",
          });
          done();
        }
      });
    },
    editImage(formData, index, fileList) {
      // console.log("edit data", formData, index, fileList);
    },
    statusChk: function (event) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "Rahbari") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.Data[0].IsAdministrator = true;
        } else {
          this.$store.state.TarifKarbaran.Data[0].IsAdministrator = false;
        }
      }
      if (checkBox.id == "Modir") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.Data[0].IsUserAdmin = true;
        } else {
          this.$store.state.TarifKarbaran.Data[0].IsUserAdmin = false;
        }
      }
      if (checkBox.id == "Disable") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.Data[0].Archive = true;
        } else {
          this.$store.state.TarifKarbaran.Data[0].Archive = false;
        }
      }
    },
  },
  created() {
    let info;
    let list = [];
    for (let index = 0; index < this.Data.length; index++) {
      info = this.Data[index];
      list.push(info);
    }
    this.DataAxios = list[0];
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
}
</style>
